import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Simple } from '../../../templates/Simple';

export const Adhoc: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/Adhoc.${label}.${locale}.json`)}>
      <AdhocComponent />
    </I18nProvider>
  );
};

export const AdhocComponent: FC = () => {
  const { state } = useMeterReadingsFlow();
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.Adhoc'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Simple
      title={t('adhoc.title')}
      content={t('adhoc.content')}
      buttonHref={t('adhoc.buttonLink.href')}
      buttonText={t('adhoc.buttonLink.text')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('adhoc.imageSrc')}`,
        },
      }}
    />
  );
};
